import React from 'react';
import { string } from 'prop-types';

import './store-details.scss';

export const StoreName = ({ name, storeId }) => {
  return (
    <div className="store-name">
      {name} #{storeId}
    </div>
  );
};

StoreName.propTypes = {
  name: string.isRequired,
  storeId: string.isRequired
};